import React, { useEffect, useMemo, useState } from 'react';
import { LICENSE_CHAGES_TYPE, SERVICES_CODES } from 'app/config/services';

import _ from 'lodash';

import {
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
} from '@material-ui/core';
import licenseEndpoint from 'app/api/services/licenseEndpoint';
import SaveButton from 'app/components/SaveButton';
import helpers from 'app/utils/helpers';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';

import notification from 'app/config/notification';
import { injectIntl } from 'react-intl';
import { STATUS_CODES } from 'app/config/status';

import { fecthLicenseChangeTypes } from 'app/store/slices/license';
import { useDispatch, useSelector } from 'react-redux';
import { Field } from 'formik';

import styles from './styles';
import CustomPaginationActionsTable from 'app/components/TableList/TableList';
const useStyles = makeStyles(styles);

const RequestData = props => {
  const { classes, request } = props;

  return (
    <Grid container spacing={0} className={classes.requestResult}>
      <Grid item xs={12} sm={6}>
        <b>Solicitação {request.nuSolicitacaoFmt}</b>
      </Grid>
      <Grid item xs={12} sm={6}>
        Data solicitação: {moment.utc(request.dtSolicitacao).format('DD/MM/YYYY')}
      </Grid>
      <Grid item xs={12}>
        Empresa: {request.nmEmpresa}
      </Grid>
      <Grid item xs={12}>
        CNPJ: {helpers.formatarDocumento(request.deCpfCnpj ? request.deCpfCnpj : '')}
      </Grid>
      <Grid item xs={12}>
        Serviço: {request.nmServico}
      </Grid>
    </Grid>
  );
};

const Search = props => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    intl,
    openDrawer,
    onCloseDrawer,
    handleSelectRequest,
    contextProps: { isInternalForm, canEdit, mainColor },
  } = props;

  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const [value, setValue] = useState(null);
  const [changeType, setChangeType] = useState(null);

  const [requests, setRequests] = useState([]);

  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({
    segundaVia: true,
    situacoes: [{ cdSituacao: STATUS_CODES.APROVADO }],
  });

  const licenseChangeTypes = useSelector(state => state.license.licenseChangeTypes);
  const internalNewRequest = useSelector(state => state.forms.internalNewRequest);
  const { activeCompany } = useSelector(state => state.company);

  const filteredLicenseChangeTypes = useMemo(() => {
    const tempLicenseChangeTypes = _.clone(licenseChangeTypes);
    let boSituacao = !activeCompany?.boSituacaoOrgao;
    if(internalNewRequest && internalNewRequest.company){
      boSituacao = !internalNewRequest.company.boSituacaoOrgao;
    }
    
    if (boSituacao) {
      const indexToRemove = tempLicenseChangeTypes.findIndex(
        el => el.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.MUDANCA_RAZAO_SOCIAL
      );
      tempLicenseChangeTypes.splice(indexToRemove, 1);
    }
    
    if (value && requests.length > 0) {
      const request = _.find(requests, ['cdSolicitacao', Number(value)]);
      const { cdServico } = request;

      let indexesToRemove = [];

      if (cdServico === SERVICES_CODES.LICENCA_TURISMO) {
        indexesToRemove = [
          LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO,
          LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO,
        ];
      }

      if (cdServico === SERVICES_CODES.LICENCA_VINCULADA) {
        indexesToRemove = [
          LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO,
          LICENSE_CHAGES_TYPE.ALTERAR_PROPRIETARIO_VEICULO,
          LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO,
        ];
      }

      if (indexesToRemove.length > 0) {
        return tempLicenseChangeTypes.filter(
          license => !indexesToRemove.includes(license.cdTipoAlteracaoLicenca)
        );
      }
    }

    return tempLicenseChangeTypes;
  }, [activeCompany, internalNewRequest, licenseChangeTypes, requests, value]);

  const handleChange = event => {
    setValue(event.target.value);
  };

  const handleChangeType = event => {
    setChangeType(event.target.value);
  };

  const onChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const init = () => {
      if(internalNewRequest && internalNewRequest.company){
        const temp = { ...filters };
        temp['cdEmpresa'] = internalNewRequest.company.cdEmpresa;
        setFilters(temp);
      }
    }
    init();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalNewRequest]);

  useEffect(() => {
    setLoading(true);
    const findRequests = async () => {
      const search = {
        page: page,
        size: pageSize,
        request: { ...filters },
      };
      const response = await licenseEndpoint.getLicenses(search);
      if (response?.status === 200 && response.data) {
        const requestsTemp = [];
        const rowsTemp = [];

        let index = 0;
        for (const r of response.data.content) {
          const temp = { ...r };
          requestsTemp.push(temp);

          const rowsPrepared = await prepareData(temp, index);
          rowsTemp.push(rowsPrepared);
          index++;
        }
        setPagination(response.data);
        setValue(null);
        setRequests(requestsTemp);
        setRows(rowsTemp);
      }
      setLoading(false);
    };
    findRequests();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, page, pageSize]);

  const handleSearch = async v => {
    const temp = { ...filters };
    temp['txtBusca'] = v || search;
    if(internalNewRequest && internalNewRequest.company){
      temp['cdEmpresa'] = internalNewRequest.company.cdEmpresa;
    }
    setFilters(temp);
  };

  const columns = useMemo(() => {
    let fields = [
      {
        title: '',
        field: 'cdSolicitacao',
        align: 'left',
      },
    ];
    return fields;
  }, []);

  const prepareData = async (content, i) => {
    return {
      originalData: content,
      cdSolicitacao: (
        <>
          <FormControlLabel
            key={`req-${i}`}
            className={classes.radio}
            value={String(content.cdSolicitacao)}
            control={<Radio />}
            label={<RequestData request={content} classes={classes} />}
          />
        </>
      ),
    };
  };

  useEffect(() => {
    const init = async () => {
      if (openDrawer) {
        handleSearch('');
        if (licenseChangeTypes.length === 0) {
          await dispatch(fecthLicenseChangeTypes());
        }
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, openDrawer]);

  const handleSave = async () => {
    if (requests) {
      const request = _.find(requests, ['cdSolicitacao', Number(value)]);
      if (request && changeType) {
        const hasLicenseInProgress = await licenseEndpoint.checkLicenseInProgress(
          request.cdLicencaOrigem || request.cdLicenca
        );
        if (hasLicenseInProgress.status === 200 && hasLicenseInProgress.data) {
          notification(
            intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.HAS_LICENSE_IN_PROGRESS' }),
            { toastId: 'HAS_LICENSE_IN_PROGRESS', type: 'error' }
          );
          return;
        }
        onCloseDrawer();
        handleSelectRequest(request, changeType);
      } else {
        notification(
          intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.NO_REQUEST_AND_TYPE_SELECTED' }),
          { toastId: 'NO_REQUEST_AND_TYPE_SELECTED', type: 'warning' }
        );
      }
    }
  };

  return (
    <Grid container spacing={3} className={classes.containerForm}>
      <Grid item xs={12}>
        <FormControl fullWidth variant="outlined">
          <InputLabel htmlFor="outlined-adornment-search">
            Digite o Nº Solicitação, ou CNPJ ou Nome da empresa
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-search"
            value={search}
            onChange={e => setSearch(e.target.value)}
            // onBlur={e => handleSearch(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => handleSearch()}
                  onMouseDown={() => {}}
                  edge="end"
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            labelWidth={400}
          />
        </FormControl>
      </Grid>

      {loading && (
        <Grid item xs={12} className={classes.centerProgress}>
          <CircularProgress size={18} />
        </Grid>
      )}

      {!loading && (
        <Grid item xs={12}>
          {rows && rows.length > 0 && (
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <FormControl fullWidth component="fieldset">
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    value={value}
                    onChange={handleChange}
                  >
                    <CustomPaginationActionsTable
                      loading={loading}
                      columns={columns}
                      rows={rows}
                      hideFilterOrder={true}
                      hideItemOrder={true}
                      hideHeader={true}
                      placeholderSearch="Busca"
                      pagination={pagination}
                      onChangePage={onChangePage}
                      onChangeRowsPerPage={onChangeRowsPerPage}
                      onClickOrder={() => {}}
                      onClickRow={() => {}}
                      onChangeInitialDate={() => {}}
                      onChangeFinalDate={() => {}}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <FormControl
                  variant="filled"
                  margin="dense"
                  fullWidth
                  style={{ marginTop: '50px', marginBottom: '30px' }}
                  onChange={e => handleChangeType(e)}
                >
                  <Field
                    name="cdTipoAlteracaoLicenca"
                    id="cdTipoAlteracaoLicenca"
                    native
                    as={Select}
                  >
                    <option aria-label="None" value="">
                      Selecione
                    </option>
                    {value &&
                      filteredLicenseChangeTypes.map((c, index) => (
                        <option key={`type-${index}`} value={c.cdTipoAlteracaoLicenca}>
                          {c.deTipoAlteracaoLicenca}
                        </option>
                      ))}
                  </Field>
                </FormControl>
              </Grid>
            </Grid>
          )}

          {(!requests || requests.length === 0) && (
            <Grid item xs={12} className={classes.noResults}>
              Nenhuma solicitação encontrada
            </Grid>
          )}
        </Grid>
      )}
      <SaveButton
        mainColor={mainColor}
        hideActionBtn={false}
        isInternalForm={isInternalForm}
        canEdit={canEdit}
        onCancel={() => {
          onCloseDrawer();
        }}
        onSave={() => {
          handleSave();
        }}
        cancelLabel={'Voltar'}
        saveLabel={'Confirmar'}
      />
    </Grid>
  );
};

export default injectIntl(Search);
